import { render, staticRenderFns } from "./global-alert.vue?vue&type=template&id=124a6da6&scoped=true"
import script from "./global-alert.vue?vue&type=script&lang=js"
export * from "./global-alert.vue?vue&type=script&lang=js"
import style0 from "./global-alert.vue?vue&type=style&index=0&id=124a6da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a6da6",
  null
  
)

export default component.exports